import React, { useMemo, useState } from "react";
import styles from '../../App.module.css';
import DotSteps from "../../components/DotSteps";
// import RadialProgress from "../../components/RadialProgress";


// --------------------------------------
const QUESTIONS = [
  // Intenção principal (roteamento)
  {
    id: "q1_tourism_only",
    text: "A viagem é só a turismo/visita/negócios e você NÃO irá trabalhar nos EUA?",
    yesSets: ["tourismOnly"],
    noSets: [],
  },
  {
    id: "q2_study",
    text: "Você pretende estudar nos EUA?",
    yesSets: ["study"],
    noSets: [],
  },
  {
    id: "q3_offer",
    text: "Você tem oferta de trabalho de uma empresa nos EUA?",
    yesSets: ["offer"],
    noSets: [],
  },
  {
    id: "q4_intraCompany",
    text: "Você será transferido(a) pela MESMA empresa/grupo onde já trabalha?",
    yesSets: ["intraCompany"],
    noSets: [],
  },
  {
    id: "q5_k1",
    text: "Você é noivo(a)/namorado(a) de um cidadão(ã) americano(a)?",
    yesSets: ["k1"],
    noSets: [],
  },
  {
    id: "q6_invest",
    text: "Você pretende investir ou gerenciar um negócio nos EUA?",
    yesSets: ["invest"],
    noSets: [],
  },
  {
    id: "q7_not_brazilian",
    text: "Seu passaporte é Brasileiro?",
    yesSets: [],
    noSets: ["not_brazilian"],
  },
  {
    id: "q7_vwp",
    text: "Seu passaporte é Europeu, Chileno ou Australiano??",
    yesSets: ["vwp"],
    noSets: [],
    askIfAll: ["not_brazilian"],
  },

  // Sub-intenções
  {
    id: "q8_hasI20",
    text: "(Estudo) Você JÁ tem o alguma matrícula ou formulário I-20 emitido?",
    yesSets: ["hasI20"],
    noSets: [],
    askIfAll: ["study"],
  },
  {
    id: "q9_academicFullTime",
    text: "(Estudo) O curso é acadêmico (faculdade/college) em tempo integral?",
    yesSets: ["academicFullTime"],
    noSets: [],
    askIfAll: ["study"],
  },
  {
    id: "q10_vocational",
    text: "(Estudo) O curso é técnico/vocacional? (até 6 meses, não acadêmico)",
    yesSets: ["vocational"],
    noSets: [],
    askIfAll: ["study"],
  },
  {
    id: "q11_specialty",
    text: "(Trabalho) O cargo exige diploma de bacharel (ocupação de especialidade)?",
    yesSets: ["specialtyOccupation"],
    noSets: [],
    askIfAll: ["offer"],
  },
  {
    id: "q12_l1_12mo",
    text: "(Transferência) Você trabalhou 12+ meses no grupo (últimos 3 anos)?",
    yesSets: ["l1_12mo"],
    noSets: [],
    askIfAll: ["intraCompany"],
  },
  {
    id: "q13_achievements",
    text: "Você tem conquistas de alto nível (prêmios relevantes, mídia, publicações, patentes)?",
    yesSets: ["extraordinary"],
    noSets: [],
  },
  {
    id: "q14_e2_treaty",
    text: "(Investimento) Seu passaporte é de país com tratado E (E-2)?",
    yesSets: ["e2_treaty"],
    noSets: [],
    askIfAll: ["invest"],
  },

  // Elegibilidade prática (vínculos/risco)
  {
    id: "q16_funds",
    text: "Você tem recursos financeiros suficientes para a viagem/curso/estadia?",
    yesSets: ["fundsOk"],
    noSets: ["fundsLow"],
  },
  {
    id: "q17_return",
    text: "Você manterá residência fora dos EUA e pretende voltar após a estadia?",
    yesSets: ["intendsReturn"],
    noSets: [],
  },
  {
    id: "q18_job_br",
    text: "Você tem emprego/renda no Brasil?",
    yesSets: ["tie_job"],
    noSets: [],
  },
  {
    id: "q19_family_br",
    text: "Você tem laços familiares/dependentes no Brasil?",
    yesSets: ["tie_family"],
    noSets: [],
  },
  {
    id: "q20_travelHistory",
    text: "Você já viajou para países com visto rigoroso (UE/UK/Canadá/Japão) e voltou no prazo?",
    yesSets: ["travelHistory"],
    noSets: [],
  },
  {
    id: "q21_risk",
    text: "Você já teve negativa de visto, overstay ou violação migratória nos EUA?",
    yesSets: ["risk_history"],
    noSets: [],
  },

  // Atalhos operacionais (úteis p/ B1/B2)
  {
    id: "q22_iwp",
    text: "Seu B1/B2 venceu há <= 48 meses e você já coletou biometria antes?",
    yesSets: ["iwp"],
    noSets: [],
    askIfAny: ["tourismOnly"],
  },
  {
    id: "q23_transit",
    text: "Seu caso é apenas trânsito/embarque (sem entrar nos EUA)?",
    yesSets: ["transit"],
    noSets: [],
  },
];

// Ordem recomendada — o motor pula automaticamente o que não se aplica
const ORDERED_IDS = [
  "q1_tourism_only",
  "q2_study",
  "q8_hasI20",
  "q9_academicFullTime",
  "q10_vocational",
  "q3_offer",
  "q4_intraCompany",
  "q5_k1",
  "q6_invest",
  "q7_not_brazilian",
  "q7_vwp",
  
  "q11_specialty",
  "q12_l1_12mo",
  "q13_achievements",
  "q14_e2_treaty",
  "q16_funds",
  "q17_return",
  "q18_job_br",
  "q19_family_br",
  "q20_travelHistory",
  "q21_risk",
  "q22_iwp",
  "q23_transit",
];

// --------------------------------------
// 2) Regras de correspondência (VISAS)
//    requires: fatos obrigatórios; blocks: incompatibilidades; weights: reforços/penalidades
// --------------------------------------
const RULES = {
  B2: {
    requires: ["tourismOnly"],
    weights: {
      fundsOk: 25,
      tie_job: 20,
      tie_family: 20,
      travelHistory: 10,
      vwp: 5, // ter VWP pode reforçar perfil organizado (apesar de B2 ≠ ESTA)
      risk_history: -30,
      fundsLow: -25,
    },
    explain: [
      "Turismo/negócios sem emprego nos EUA.",
      "Comprovar recursos e laços no Brasil.",
    ],
  },
  ESTA: {
    requires: ["tourismOnly", "vwp"],
    weights: { fundsOk: 15, travelHistory: 10, risk_history: -40 },
    explain: [
      "Elegível ao Programa de Isenção (ESTA) para estadias curtas.",
      "Sujeito a requisitos de segurança e permanência máxima.",
    ],
  },
  F1: {
    requires: ["study", "hasI20", "academicFullTime"],
    weights: { fundsOk: 30, tie_job: 10, tie_family: 10, risk_history: -30 },
    explain: [
      "Estudo acadêmico com I-20/SEVIS e comprovação financeira.",
      "Intenção temporária e vínculos fora dos EUA.",
    ],
  },
  M1: {
    requires: ["study", "vocational"],
    weights: { fundsOk: 25, risk_history: -30 },
    explain: [
      "Curso técnico/vocacional (não acadêmico).",
      "Exige comprovação financeira e intenção temporária.",
    ],
  },
  H1B: {
    requires: ["offer", "specialtyOccupation"],
    weights: { risk_history: -20 },
    explain: [
      "Oferta em ocupação de especialidade; exige petition (I-129) do empregador.",
    ],
  },
  L1: {
    requires: ["intraCompany", "l1_12mo"],
    weights: { risk_history: -15 },
    explain: [
      "Transferência intraempresa; vínculo prévio de 12+ meses no grupo.",
    ],
  },
  O1: {
    requires: ["extraordinary"],
    weights: { risk_history: -15 },
    explain: [
      "Habilidade extraordinária reconhecida (evidências fortes).",
    ],
  },
  E2: {
    requires: ["invest", "e2_treaty"],
    weights: { fundsOk: 20, risk_history: -15 },
    explain: [
      "Investidor com passaporte de país com tratado E.",
    ],
  },
  K1: {
    requires: ["k1"],
    weights: { risk_history: -10 },
    explain: [
      "Noivado com cidadão americano; casamento em 90 dias após entrada.",
    ],
  },
  C1D: {
    requires: ["transit"],
    weights: {},
    explain: ["Trânsito/embarcação (C-1/D) quando aplicável."],
  },
};

// --------------------------------------
// 3) Utilitários do motor
// --------------------------------------
const getBand = (score) =>
  score >= 80 ? "Muito favorável" :
    score >= 60 ? "Favorável" :
      score >= 40 ? "Neutro" :
        score >= 20 ? "Desfavorável" : "Improvável";

function isApplicable(question, facts) {
  const { askIfAll, askIfAny, excludeIfAny } = question;
  if (askIfAll && askIfAll.some((f) => !facts[f])) return false;
  if (askIfAny && !askIfAny.some((f) => facts[f])) return false;
  if (excludeIfAny && excludeIfAny.some((f) => facts[f])) return false;
  return true;
}

function recomputeFactsFromAnswers(answers) {
  // Recalcula os fatos do zero para suportar "voltar"
  const facts = {};
  for (const q of QUESTIONS) {
    const ans = answers[q.id];
    if (ans === true) {
      (q.yesSets || []).forEach((f) => (facts[f] = true));
    } else if (ans === false) {
      (q.noSets || []).forEach((f) => (facts[f] = true));
    }
  }
  return facts;
}

function nextQuestionId(answers, facts) {
  for (const id of ORDERED_IDS) {
    if (answers[id] !== undefined) continue; // já respondida
    const q = QUESTIONS.find((x) => x.id === id);
    if (!q) continue;
    if (isApplicable(q, facts)) return id;
  }
  return null; // acabou
}

function evaluate(facts, rules) {
  const results = Object.entries(rules).map(([visa, rule]) => {
    // Portas de entrada
    if (rule.requires?.some((r) => !facts[r])) {
      return { visa, fit: 0, band: "Improvável", why: rule.explain };
    }
    if (rule.blocks?.some((b) => facts[b])) {
      return { visa, fit: 0, band: "Improvável", why: rule.explain };
    }

    // Prior neutro + pesos
    let score = 50;
    for (const [k, w] of Object.entries(rule.weights || {})) {
      if (facts[k]) score += w;
    }
    score = Math.max(0, Math.min(100, score));
    return { visa, fit: score, band: getBand(score), why: rule.explain };
  });

  const ranked = results.filter((r) => r.fit > 0).sort((a, b) => b.fit - a.fit);
  return {
    top: ranked.slice(0, 3),
    alternatives: ranked.slice(3, 6),
    raw: results,
  };
}

function RadialProgress({ value = 0, size = 84, strokeWidth = 8, label }) {
  const clamped = Math.max(0, Math.min(100, value));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = (clamped / 100) * circumference;
  const rest = circumference - dash;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-label={`${clamped}%`}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="rgba(0,0,0,0.08)"
        strokeWidth={strokeWidth}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={`${dash} ${rest}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ color: "green" }} // indigo-600; mude se quiser
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontWeight="700"
        fontSize={size * 0.28}
        fill="#111827"
      >
        {clamped}
        <tspan fontSize={size * 0.18} fontWeight="600" fill="#6B7280">%</tspan>
      </text>
    </svg>
  );
}



// --------------------------------------
// 4) UI — Componente principal
// --------------------------------------
export default function VisaMatchApp() {
  const [showDebug, setShowDebug] = useState(false);
  const [started, setStarted] = useState(false);
  const [answers, setAnswers] = useState({});
  const [history, setHistory] = useState([]);
  // já que você usa facts em vários lugares, garanta que ele venha antes:
  const facts = useMemo(() => recomputeFactsFromAnswers(answers), [answers]);
  // pergunta atual é a próxima aplicável segundo o motor
  const currentId = useMemo(() => nextQuestionId(answers, facts), [answers, facts]);
  // terminou quando não há mais pergunta aplicável
  const finished = currentId === null;

  const applicableIds = useMemo(() => {
    return ORDERED_IDS.filter((id) => {
      const q = QUESTIONS.find((x) => x.id === id);
      return q && isApplicable(q, facts);
    });
  }, [facts]);

  const progress = useMemo(() => {
    const total = applicableIds.length || ORDERED_IDS.length;
    const answeredApplicable = applicableIds.filter((id) => answers[id] !== undefined).length;
    return Math.round((answeredApplicable / total) * 100);
  }, [answers, applicableIds]);

  const results = useMemo(() => evaluate(facts, RULES), [facts]);
  function handleReset() {
    setAnswers({});
    setHistory([]);
  }


  const handleAnswer = (value) => {
    setAnswers((prev) => ({ ...prev, [currentId]: value }));
    setHistory((prev) => [...prev, currentId]);
  };


  const handleBack = () => {
    setHistory((prev) => {
      const copy = [...prev];
      const last = copy.pop();
      if (!last) return prev;
      setAnswers((ans) => {
        const next = { ...ans };
        delete next[last];
        return next;
      });
      return copy;
    });
  };


  const currentIndex = Math.max(0, applicableIds.indexOf(currentId));
  const total = applicableIds.length;


  if (!started) {
    return (
      <div className={styles.app} style={{ textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ padding: "20px" }}>
          {/* imagem acima do título */}
          <img
            src="/img.svg"
            alt="Ilustração do quiz de visto americano"
            style={{
              width: "100%",          // ajuste o tamanho
              height: "auto",
              maxWidth: "400px",   // largura máxima
              marginBottom: "20px",    // espaçamento abaixo da imagem
            }}
          />
          <header className="mb-6">
            <h1 style={{ fontSize: '32px', fontWeight: '600', marginBottom: '10px' }}>
              Descubra agora qual o <span style={{ fontWeight: "800" }}>visto perfeito</span>  para você
            </h1>
            <p style={{ fontSize: "20px" }}>
              Responda algumas perguntas de sim ou não e nós indicaremos qual o melhor visto para o seu perfil!
            </p>
          </header>
          <button
            style={{
              backgroundColor: "green", color: "white", marginTop: "20px",
            }}
            className={styles.buttonQuiz}
            onClick={() => setStarted(true)}
          >
            Iniciar Análise de Perfil
          </button>
        </div>
      </div>
    );
  }



  return (
    <div className={styles.app} style={{ textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <div className="w-full max-w-3xl">

        {/* Progress */}
        <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4">
          {!finished && <DotSteps total={total} currentIndex={currentIndex} />}
          <div
            className="bg-indigo-600 h-2.5 rounded-full transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div style={{ fontWeight: "600" }}>Pergunta {history.length + 1} ({progress}%)</div>


        {/* Card principal */}
        <div className="bg-white rounded-2xl shadow p-5 md:p-6">
          {!finished ? (
            <QuestionCard
              question={QUESTIONS.find((q) => q.id === currentId)}
              onYes={() => handleAnswer(true)}
              onNo={() => handleAnswer(false)}
              onBack={history.length ? handleBack : null}
              answeredCount={history.length}
            />
          ) : (
            <ResultsCard
              results={results}
              facts={facts}
              onReset={handleReset}
            />
          )}
        </div>


        {/* <div className="mt-4 flex items-center justify-between">
          <button
            onClick={() => setShowDebug((v) => !v)}
            className="text-xs text-gray-500 hover:text-gray-700 underline"
            style={{
              padding: "5px 5px", backgroundColor: "orange", color: "white",
              borderRadius: "5px", border: "none", cursor: "pointer",
              display: "flex", alignItems: "center", gap: "5px",
            }}
          >
            {showDebug ? "Ocultar" : "Mostrar"} debug
          </button>
        </div> */}

        {showDebug && (
          <DebugPanel answers={answers} facts={facts} results={results} />
        )}
      </div>
    </div>
  );
}

function QuestionCard({ question, onYes, onNo, onBack, answeredCount }) {
  if (!question) return null;
  return (

    <div style={{ padding: "20px" }}>
      <div className="flex flex-col gap-4"
        style={{ backgroundColor: "#fff", margin: "10px 0px", padding: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
      >

        <div >
          <h2 className="text-xl md:text-2xl font-semibold text-gray-900 mt-1">{question.text}</h2>
          {question.askIfAll || question.askIfAny ? (
            <p className="text-[12px] text-gray-500 mt-1">(Pergunta exibida conforme suas respostas anteriores)</p>
          ) : null}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <button
            className={styles.buttonQuiz}
            style={{
              backgroundColor: "green", color: "white",
            }}
            onClick={onYes}
          >
            Sim
          </button>
          <button
            style={{
              backgroundColor: "red", color: "white",
            }}
            onClick={onNo}
            className={styles.buttonQuiz}
          >
            Não
          </button>
        </div>

      </div>
      {onBack && (
        <div className="flex justify-between items-center mt-2">
          <button className={styles.buttonQuiz} style={{ fontSize: "16px" }} onClick={onBack}> Voltar pergunta</button>
        </div>
      )}
    </div>

  );
}



function ResultsCard({ results, facts, onReset }) {
  // ordena todos por fit desc e ignora os de fit 0
  const all = useMemo(
    () => results.raw.filter(r => r.fit > 0).sort((a, b) => b.fit - a.fit),
    [results]
  );

  return (
    <div >
      <div>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: 600,
            color: "#111827", // text-gray-900
            marginBottom: "4px",
          }}
        >
          Resultados
        </h2>
        <p
          style={{
            color: "#4B5563", // text-gray-600
            marginTop: "4px",
          }}
        >
          Vemos abaixo todas as categorias avaliadas para o seu perfil, com a porcentagem representada no medidor circular.
        </p>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        {all.length === 0 && (
          <div
            style={{
              gridColumn: "1 / -1",
              color: "#4B5563", // text-gray-600
            }}
          >
            Nenhuma categoria apresentou critérios mínimos. Revise suas respostas ou fale com um especialista.
          </div>
        )}

        {all.map((r) => (
          <VisaCard key={r.visa} item={r} />
        ))}
      </div>


      <div className="flex items-center justify-between mt-2">
        <button
          onClick={onReset}
          className={styles.buttonQuiz} style={{ backgroundColor: "#ff7e7eff", color: "white" , fontSize: "16px"}}
        >
          Reiniciar Ánalise de Perfil
        </button>
        <div className="text-[12px] text-gray-500">
          Dica: fortaleça recursos/vínculos e regularize pendências migratórias antes de aplicar.
        </div>
      </div>


      {/* Resumo dos fatores principais */}
      <div className="mt-2 p-4 rounded-xl bg-indigo-50 border border-indigo-100">
        <div className="text-sm font-semibold text-indigo-900">Fatores que influenciaram sua avaliação</div>
        <ul className="text-sm text-indigo-900 list-disc ml-5 mt-1">
          {facts.fundsLow && <li>Recursos podem estar insuficientes (impacto negativo).</li>}
          {facts.risk_history && <li>Histórico de negativa/overstay (impacto negativo).</li>}
          {facts.tie_job && <li>Emprego/renda no Brasil (vínculo positivo).</li>}
          {facts.tie_family && <li>Laços familiares no Brasil (vínculo positivo).</li>}
          {facts.travelHistory && <li>Histórico de viagens e retornos no prazo (positivo).</li>}
          {facts.vwp && facts.tourismOnly && <li>Possível uso do ESTA para viagens curtas (se elegível).</li>}
          {facts.hasI20 && <li>I-20 emitido para estudos (pré‑requisito F‑1).</li>}
          {facts.specialtyOccupation && <li>Oferta de especialidade (H‑1B exige petition do empregador).</li>}
          {facts.l1_12mo && <li>Vínculo 12+ meses no grupo (critério L‑1).</li>}
          {facts.e2_treaty && facts.invest && <li>Passaporte com tratado E + intenção de investir (E‑2).</li>}
        </ul>
      </div>
    </div >
  );
}









function VisaCard({ item, subtle }) {
  const badgeColor =
    item.band === "Muito favorável" ? "bg-emerald-100 text-emerald-900" :
      item.band === "Favorável" ? "bg-lime-100 text-lime-900" :
        item.band === "Neutro" ? "bg-amber-100 text-amber-900" :
          item.band === "Desfavorável" ? "bg-orange-100 text-orange-900" : "bg-rose-100 text-rose-900";

  return (
    <div
      style={{
        // backgroundColor:"red",
        margin: "10px",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        padding: "20px",
        border: "4px solid var(--corPrimaria)",
        width: "80%",
      }}
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="text-sm text-gray-500">Categoria</div>
          <div className="text-lg font-semibold text-gray-900" style={{ fontSize: "32px", fontWeight: "800" }}>{item.visa}</div>
        </div>
        <div className={`text-xs px-2 py-1 rounded-full ${badgeColor}`}>{item.band}</div>
      </div>

      <div className="flex items-center gap-4">
        <div className="shrink-0">
          <RadialProgress value={item.fit} size={84} strokeWidth={8} />
        </div>
        <div className="min-w-0">
          {/* <div className="text-3xl font-bold tracking-tight text-gray-900 leading-6">
            {item.fit}<span className="text-base font-medium text-gray-500">/100</span>
          </div> */}
          {item.why?.length > 0 && (
            <ul className="mt-2 text-sm text-gray-700 list-disc ml-5 space-y-1">
              {item.why.slice(0, 3).map((t, i) => <li key={i}>{t}</li>)}
            </ul>
          )}
        </div>
      </div>

      {/* <div className="mt-3 text-xs text-gray-500">
        Observação: casos com petition (ex.: H-1B/L-1/O-1) exigem aprovação no USCIS antes da etapa consular.
      </div> */}
    </div>
  );
}


function DebugPanel({ answers, facts, results }) {
  return (
    <div style={{ width: "100%", maxWidth: "400" }}>
      <div className="text-sm font-semibold mb-2">DEBUG</div>
      <div className="grid md:grid-cols-3 gap-4 text-xs">
        <div>
          <div className="font-semibold mb-1">Answers</div>
          <pre className="bg-gray-50 p-2 rounded overflow-auto max-h-60">{JSON.stringify(answers, null, 2)}</pre>
        </div>
        <div>
          <div className="font-semibold mb-1">Facts</div>
          <pre className="bg-gray-50 p-2 rounded overflow-auto max-h-60">{JSON.stringify(facts, null, 2)}</pre>
        </div>
        <div>
          <div className="font-semibold mb-1">Results (raw)</div>
          <pre className="bg-gray-50 p-2 rounded overflow-auto max-h-60">{JSON.stringify(results, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}
